import { render, staticRenderFns } from "./returnJourney.vue?vue&type=template&id=b6cec5fa&scoped=true&lang=true"
import script from "./returnJourney.vue?vue&type=script&lang=js"
export * from "./returnJourney.vue?vue&type=script&lang=js"
import style0 from "./returnJourney.vue?vue&type=style&index=0&id=b6cec5fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6cec5fa",
  null
  
)

export default component.exports